require('../../../retail/js/feature/component-screening-test-spot');